<template>
    <div class="Field__Component">
        <div v-if="value"><slot><router-link :to="`/drivers/${value.Id}`">
        {{value && value.Name}}</router-link></slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldDriver',
    props: ['value', 'item'],
};
</script>

<style>

</style>
